import Popup from "../../../../../../common/components/popup";
import SettlementRequestItems from "./settlement-request-items";
import Settlements from "./settlement-request-items";

export const SettlementRequestItemsPopup = ({ 
  selectedSettlementRequest,
  closeModal,
  
}: any) => {

    return (
      <>
        <Popup onClose={closeModal}>
          <SettlementRequestItems
            selectedSettlementRequest={selectedSettlementRequest}
          />
        </Popup>
      </>
    )
  }